import { useState } from 'react';
import { fetchPostOffersSelect } from '@iwoca/lapi-client/edge';
import { Button, Message } from '@iwoca/orion';
import { useOffers } from 'components/Signup/hooks/useOffers';
import { useIntroducerData } from 'contexts/IntroducerData/IntroducerData.context';
import { useAmplitude } from 'hooks/useAmplitude';
import { useGetIntroducerApplication } from 'lendingApi/lendingApiHooks';
import { useNavigate } from 'react-router-dom';
import { IwQueryClient } from 'store/IwQueryClient';
import { getDurationInMonths } from 'utils/durationHelper';
import { PATH_NAMES } from 'utils/routes/pathNames';
import { AMPLITUDE_EVENTS } from 'utils/tracking/tracking.events';
import styles from './InstantOfferButton.module.css';

export const InstantOfferButton = () => {
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const { offers, setSelectOfferError, selectOfferError, isReintroduction } =
    useOffers({
      getOffersEnabled: true,
    });
  const { application } = useGetIntroducerApplication();
  const { trackEvent } = useAmplitude();
  const { checkIntroducerPermission } = useIntroducerData();

  const instantOffer = offers?.filter(
    (offer) => offer.offer_type === 'confirmed',
  )?.[0];

  if (!instantOffer) {
    return null;
  }

  const isFlexi24 = getDurationInMonths(instantOffer.duration) === 24;

  const formaliseOffer = async () => {
    setIsLoading(true);
    trackEvent(AMPLITUDE_EVENTS.acceptRightNowClicked, {
      'Product type': isFlexi24
        ? 'Flexi24 confirmed offer'
        : 'Flexi confirmed offer',
      'Max amount': instantOffer.max_amount,
      Reintroduction: isReintroduction,
    });

    try {
      await fetchPostOffersSelect({ offerId: instantOffer.offer_id });

      IwQueryClient.getOrCreate().invalidateQueries({
        queryKey: ['fetchGetApplication'],
      });

      navigate(
        PATH_NAMES.application({ applicationId: application?.application_uid }),
      );
    } catch {
      return setSelectOfferError(true);
    }

    setIsLoading(false);
  };

  return (
    <>
      <Button
        loading={isLoading}
        onClick={formaliseOffer}
        className={styles.button}
        disabled={!checkIntroducerPermission('can_interact_with_offers')}
      >
        Proceed with offer
      </Button>

      {selectOfferError && (
        <Message
          className={styles.message}
          message="Something went wrong, please try again later."
          type="error"
        />
      )}
    </>
  );
};
